/* dev-tools-expanded.tsx generated by @compiled/babel-plugin v0.17.1 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
var _19 = "._1wybw1gv{font-size:13px}";
var _18 = "._ect4ixyu{font-family:Helvetica Neue,Calibri Light,Roboto,sans-serif}";
var _17 = "._bfhk2l5j{background-color:#1e1e2e}";
var _16 = "._18m915vq{overflow-y:hidden}";
var _15 = "._1reo15vq{overflow-x:hidden}";
var _14 = "._4t3i1osq{height:100%}";
var _13 = "._1bsb1osq{width:100%}";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import { Dock } from "react-dock";
import { Tab, Tabs, TabList, TabPanel } from "./components/tabs";
import { devToolsOpenedAtom, devToolsSizeAtom, devToolTabIndexAtom } from "./state/global";
import StateTab from "./tabs/state";
import HistoryTab from "./tabs/history";
import SchemaTab from "./tabs/schema";
import PluginsTab from "./tabs/plugins";
import StructureTab from "./tabs/structure";
import SnapshotsTab from "./tabs/snapshots";
import CSSReset from "./components/css-reset";
import { NodePicker, NodePickerTrigger } from "./components/node-picker";
import SaveSnapshotButton from "./components/save-snapshot-button";
import theme from "./theme";
import { useAtom, useAtomValue } from "jotai";
import { useNodePicker } from "./state/node-picker";
var _12 = "._1hvw1o36:focus{outline-width:medium}";
var _11 = "._49pcglyw:focus{outline-style:none}";
var _10 = "._nt751r31:focus{outline-color:currentColor}";
var _9 = "._30l35y2n:hover{color:#cdd6f4}";
var _8 = "._irr33ch5:hover{background-color:rgba(205,214,244,.05)}";
var _7 = "._d0altlke:hover{cursor:pointer}";
var _6 = "._1wybf6fq{font-size:18px}";
var _5 = "._syaz4yqd{color:rgba(205,214,244,.6)}";
var _4 = "._1xi2idpf{right:0}";
var _3 = "._kqswstnw{position:absolute}";
var _2 = "._19itglyw{border:none}";
var _ = "._11q7glyw{background:none}";
var CloseButton = function CloseButton(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12]), /*#__PURE__*/React.createElement("button", {
    "data-test-id": "__prosemirror_devtools_close_button__",
    onClick: onClick,
    className: ax(["_11q7glyw _19itglyw _kqswstnw _1xi2idpf _syaz4yqd _1wybf6fq _d0altlke _irr33ch5 _30l35y2n _nt751r31 _49pcglyw _1hvw1o36"])
  }, children));
};
export default function DevToolsExpanded(_ref2) {
  var rollbackHistory = _ref2.rollbackHistory;
  var _useAtom = useAtom(devToolsOpenedAtom),
    _useAtom2 = _slicedToArray(_useAtom, 2),
    isOpen = _useAtom2[0],
    setIsOpen = _useAtom2[1];
  var defaultSize = useAtomValue(devToolsSizeAtom);
  var _useAtom3 = useAtom(devToolTabIndexAtom),
    _useAtom4 = _slicedToArray(_useAtom3, 2),
    tabIndex = _useAtom4[0],
    setTabIndex = _useAtom4[1];
  var updateBodyMargin = React.useCallback(function (devToolsSize) {
    var size = devToolsSize * window.innerHeight;
    document.querySelector("html").style.marginBottom = "".concat(size, "px");
  }, []);
  var _useNodePicker = useNodePicker(),
    _useNodePicker2 = _slicedToArray(_useNodePicker, 2),
    nodePicker = _useNodePicker2[0],
    nodePickerAPI = _useNodePicker2[1];
  var toggleOpen = React.useCallback(function () {
    setIsOpen(!isOpen);
  }, [isOpen]);
  var renderTab = React.useCallback(function (_ref3) {
    var index = _ref3.index;
    switch (index) {
      case "state":
        return /*#__PURE__*/React.createElement(StateTab, null);
      case "history":
        return /*#__PURE__*/React.createElement(HistoryTab, {
          rollbackHistory: rollbackHistory
        });
      case "plugins":
        return /*#__PURE__*/React.createElement(PluginsTab, null);
      case "schema":
        return /*#__PURE__*/React.createElement(SchemaTab, null);
      case "structure":
        return /*#__PURE__*/React.createElement(StructureTab, null);
      case "snapshots":
        return /*#__PURE__*/React.createElement(SnapshotsTab, null);
      default:
        return /*#__PURE__*/React.createElement(StateTab, null);
    }
  }, [rollbackHistory]);
  var renderDockContent = React.useCallback(function () {
    return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_13, _14, _15, _16, _17, _18, _19]), /*#__PURE__*/React.createElement("div", {
      "data-test-id": "__prosemirror_devtools_container__",
      className: ax(["_1bsb1osq _4t3i1osq _1reo15vq _18m915vq _bfhk2l5j _ect4ixyu _1wybw1gv"])
    }, /*#__PURE__*/React.createElement(CloseButton, {
      onClick: toggleOpen
    }, "\xD7"), /*#__PURE__*/React.createElement(NodePickerTrigger, {
      onClick: nodePickerAPI.activate,
      isActive: nodePicker.active
    }), /*#__PURE__*/React.createElement(SaveSnapshotButton, null), /*#__PURE__*/React.createElement(Tabs, {
      onSelect: setTabIndex,
      selectedIndex: tabIndex
    }, /*#__PURE__*/React.createElement(TabList, null, /*#__PURE__*/React.createElement(Tab, {
      index: "state"
    }, "State"), /*#__PURE__*/React.createElement(Tab, {
      index: "history"
    }, "History"), /*#__PURE__*/React.createElement(Tab, {
      index: "plugins"
    }, "Plugins"), /*#__PURE__*/React.createElement(Tab, {
      index: "schema"
    }, "Schema"), /*#__PURE__*/React.createElement(Tab, {
      index: "structure"
    }, "Structure"), /*#__PURE__*/React.createElement(Tab, {
      index: "snapshots"
    }, "Snapshots")), /*#__PURE__*/React.createElement(TabPanel, null, renderTab))));
  }, [nodePicker, nodePickerAPI, tabIndex, isOpen, renderTab]);
  return /*#__PURE__*/React.createElement(CSSReset, null, /*#__PURE__*/React.createElement(NodePicker, null), /*#__PURE__*/React.createElement(Dock, {
    position: "bottom",
    dimMode: "none",
    isVisible: true,
    defaultSize: defaultSize,
    onSizeChange: updateBodyMargin,
    zIndex: 1,
    fluid: true,
    duration: 0
  }, renderDockContent));
}